import { Model } from '@vuex-orm/core';
import Building from '@/models/Building';
import Buildingable from '@/models/Buildingable';
import Date from '@/models/Date';
import Illustration from '@/models/Illustration';
import Image from '@/models/Image';
import Imageable from '@/models/Imageable';
import Project from '@/models/Project';
import Projectable from '@/models/Projectable';

export default class Selector extends Model {
  static entity = 'selectors';

  static state() {
    return {
      viewType: 'selector',
    };
  }

  static fields() {
    return {
      id: this.uid(),
      name: this.attr(''),

      singleBuilding: this.boolean(true),

      building_ids: this.attr(null),
      overview_illustration_ids: this.attr(null),
      building_illustration_ids: this.attr(null),

      // Relationships
      buildings: this.morphToMany(
        Building,
        Buildingable,
        'building_id',
        'buildingable_id',
        'buildingable_type'
      ),
      date: this.morphOne(Date, 'dateable_id', 'dateable_type'),
      illustrations: this.hasMany(Illustration, 'selector_id'),
      images: this.morphToMany(
        Image,
        Imageable,
        'image_id',
        'imageable_id',
        'imageable_type'
      ),
      projects: this.morphToMany(
        Project,
        Projectable,
        'project_id',
        'projectable_id',
        'projectable_type'
      ),
    };
  }

  static transformer(data) {
    const selectors = [];
    data.data.forEach(item => {
      const selector = {};
      selector.id = item.id;
      selector.name = item.name;

      // Add date object to Selector object
      selector.date = {
        date: item.date,
        date_gmt: item.date_gmt,
        modified: item.modified,
        modified_gmt: item.modified_gmt,
      };

      if (item.project.length > 0) {
        selector.projects = [];
        item.project.forEach(project => {
          selector.projects.push({ id: project });
        });
      }

      if (item.acf.building_select === 'multiple') {
        selector.singleBuilding = false;

        if (item.acf.overview) {
          selector.overview_illustration_ids = [];
          selector.illustrations = [];

          item.acf.overview.forEach(item => {
            selector.illustrations.push({ id: item.illustration });
            selector.overview_illustration_ids.push(item.illustration);
          });
        }

        if (item.acf.buildings) {
          selector.buildings = [];
          selector.building_ids = [];
          selector.building_illustration_ids = {};
          item.acf.buildings.forEach(building => {
            // Add buildings array to selector.
            selector.building_ids.push(building.building.term_id);

            if (building.building_illustrations) {
              selector.building_illustration_ids[
                building.building.term_id
              ] = [];
              building.building_illustrations.forEach(item => {
                selector.building_illustration_ids[
                  building.building.term_id
                ].push(item.illustration);
              });
            }

            let availabilityId = null;
            if (building.availability) {
              availabilityId = building.availability.term_id;
            }

            let shapeItems = [];
            if (building.shapes) {
              building.shapes.forEach(shape => {
                shapeItems.push({
                  illustration: shape.illustration,
                  polygon: shape.polygon,
                  path: shape.path,
                  shapeable_id: building.building.term_id,
                  shapeable_type: 'buildings',
                });
              });
            }

            selector.buildings.push({
              id: building.building.term_id,
              shapes: shapeItems,
              availability: {
                id: availabilityId,
              },
              url: building.url,
            });
          });
        }
      } else {
        selector.singleBuilding = true;
        selector.overview_illustration_ids = [];
        selector.illustrations = [];
        if (item.acf.building_single) {
          item.acf.building_single.forEach(item => {
            selector.illustrations.push({ id: item.illustration });
            selector.overview_illustration_ids.push(item.illustration);
          });
        }
      }

      selectors.push(selector);
    });
    return selectors;
  }

  static apiConfig = {
    dataTransformer: data => this.transformer(data),
  };

  static fetch(project, baseURL) {
    let url = '/wp-json/wp/v2/selector?order=asc&per_page=100';
    if (project) {
      url = `${url}&project=${project}`;
    }
    return this.api().get(url, {
      baseURL: baseURL,
    });
  }
}
